import {
  setInvoiceGridPersistence,
  setSpvListPersistence,
} from "@app/statefx/xThunks/uiPersistGrid";

import { AppState, fxDispatch } from "./xstore";

export function sendStorageRequest(
  storageKey: keyof AppState,
  method: "GET" | "PUT",
  data = null
) {
  return new Promise((resolve, reject) => {
    if (method === "GET") {
      try {
        const state = window.fx.getState();
        const data = state[storageKey];
        if (data) {
          resolve(data || {});
        } else {
          resolve({});
        }
      } catch (error) {
        reject(error); // Reject the promise in case of error
      }
    } else if (method === "PUT") {
      try {
        if (storageKey === "uiPersistInvoiceGrid") {
          fxDispatch(setInvoiceGridPersistence(data));
        }
        if (storageKey === "uiPersistSpvList") {
          fxDispatch(setSpvListPersistence(data));
        }
        resolve(true); // Resolve the promise on success
      } catch (error) {
        reject(error); // Reject the promise in case of error
      }
    } else {
      // Handle other methods or throw an error
      reject(new Error(`Method ${method} is not supported`));
    }
  });
}
